/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoControlCenterModelsChangeMachineLicense
 */
export interface ControlcenterMelcoControlCenterModelsChangeMachineLicense {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsChangeMachineLicense
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsChangeMachineLicense
     */
    subscription_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsChangeMachineLicense
     */
    email_address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsChangeMachineLicense
     */
    language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsChangeMachineLicense
     */
    transaction_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsChangeMachineLicense
     */
    operation_type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsChangeMachineLicense
     */
    license_count?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsChangeMachineLicense
     */
    subscription_start_date?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsChangeMachineLicense
     */
    step?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsChangeMachineLicense
     */
    reduce_license_count?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsChangeMachineLicense
     */
    new_license_count?: number;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsChangeMachineLicense
     */
    new_sub_start_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsChangeMachineLicense
     */
    new_subscription_code?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsChangeMachineLicense
     */
    expiration_date?: Date | null;
}

export function ControlcenterMelcoControlCenterModelsChangeMachineLicenseFromJSON(json: any): ControlcenterMelcoControlCenterModelsChangeMachineLicense {
    return ControlcenterMelcoControlCenterModelsChangeMachineLicenseFromJSONTyped(json, false);
}

export function ControlcenterMelcoControlCenterModelsChangeMachineLicenseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoControlCenterModelsChangeMachineLicense {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'subscription_code': !exists(json, 'subscription_code') ? undefined : json['subscription_code'],
        'email_address': !exists(json, 'email_address') ? undefined : json['email_address'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'transaction_id': !exists(json, 'transaction_id') ? undefined : json['transaction_id'],
        'operation_type': !exists(json, 'operation_type') ? undefined : json['operation_type'],
        'license_count': !exists(json, 'license_count') ? undefined : json['license_count'],
        'subscription_start_date': !exists(json, 'subscription_start_date') ? undefined : json['subscription_start_date'],
        'step': !exists(json, 'step') ? undefined : json['step'],
        'reduce_license_count': !exists(json, 'reduce_license_count') ? undefined : json['reduce_license_count'],
        'new_license_count': !exists(json, 'new_license_count') ? undefined : json['new_license_count'],
        'new_sub_start_date': !exists(json, 'new_sub_start_date') ? undefined : (json['new_sub_start_date'] === null ? null : new Date(json['new_sub_start_date'])),
        'new_subscription_code': !exists(json, 'new_subscription_code') ? undefined : json['new_subscription_code'],
        'expiration_date': !exists(json, 'expiration_date') ? undefined : (json['expiration_date'] === null ? null : new Date(json['expiration_date'])),
    };
}

export function ControlcenterMelcoControlCenterModelsChangeMachineLicenseToJSON(value?: ControlcenterMelcoControlCenterModelsChangeMachineLicense | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_code': value.product_code,
        'subscription_code': value.subscription_code,
        'email_address': value.email_address,
        'language': value.language,
        'transaction_id': value.transaction_id,
        'operation_type': value.operation_type,
        'license_count': value.license_count,
        'subscription_start_date': value.subscription_start_date,
        'step': value.step,
        'reduce_license_count': value.reduce_license_count,
        'new_license_count': value.new_license_count,
        'new_sub_start_date': value.new_sub_start_date === undefined ? undefined : (value.new_sub_start_date === null ? null : value.new_sub_start_date.toISOString()),
        'new_subscription_code': value.new_subscription_code,
        'expiration_date': value.expiration_date === undefined ? undefined : (value.expiration_date === null ? null : value.expiration_date.toISOString()),
    };
}


